import React, { Component } from "react";
import "../style/addComment.scss";
import CloseIcon from "../icon/CloseIcon";
import AddIcon from "../icon/AddIcon";
import ApiEndpointConstants, {
  BASE_URL,
} from "../constants/ApiEndpointConstants";
import axios from "axios";
import Edit from "./common/Edit";
import Loading from "./common/Loading";
import SubmitIcon from "../icon/SubmitIcon";
import * as GetTieZiAPI from "../apis/GetTieZiAPI";
import * as EditTieZiAPI from "../apis/EditTieZiAPI";
import { setAPIAuthorizationToken } from "../apis/API";
import cookie from "react-cookies";
import * as EditCommentAPI from "../apis/EditCommentAPI";
import * as GetCommentAPI from "../apis/GetCommentAPI";
import queryString from "query-string";

class AddComment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgArr: [""],
      loadingShow: false,
      nickname: "",
      id: "",
      tieziid: "",
      content: "",
    };
    this.UpdateImg = this.UpdateImg.bind(this);
    this.changeInput = this.changeInput.bind(this);
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
  }

  EditRef = React.createRef();

  componentDidMount() {
    let { location } = this.props;
    console.log(location);
    let arr = queryString.parse(location.search);
    let tieziid = arr.id;
    this.setState({ tieziid });
    if (location.pathname.indexOf("/AddComment/") >= 0) {
      let id = location.pathname.replace("/AddComment/", "");
      this.toggleShow();
      GetCommentAPI.getComment(id).then((res) => {
        this.toggleShow();
        var code = res.data.code;
        if (code === 1) {
          var data = res.data.data;
          console.log(data);
          this.setState({
            imgArr: [data.logo],
            nickname: data.nickname,
            content: data.description,
            id,
          });
        }
      });
    }
  }

  UpdateImg(e, imgIndex) {
    let { imgArr } = this.state;
    const _that = this;
    var formData = new FormData();
    [...e.target.files].forEach((fileInfo, index) => {
      if (index > 0) return;
      let reads = new FileReader();
      reads.readAsDataURL(fileInfo);
      formData.append("file", fileInfo);
      axios({
        url: BASE_URL + ApiEndpointConstants.UPLOAD,
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          console.log("连上了---------");
          let url = res.data.data.url;
          console.log(url);
          imgArr[imgIndex + index] = url;
          _that.setState({ imgArr });
          e.target.value = "";
          console.error(imgArr);
        })
        .catch((err) => {
          // return reject(err);
        });
    });
  }

  toggleShow() {
    this.setState({ loadingShow: !this.state.loadingShow });
  }

  back() {
    const { history } = this.props;
    history.goBack();
  }

  changeInput(e) {
    this.setState({ nickname: e.target.value });
  }

  submit() {
    let param = cookie.load("token");
    if (param) {
      setAPIAuthorizationToken(param.token);
    }
    let { nickname, imgArr, content, id, tieziid } = this.state;
    let logo = imgArr[0];
    if (id !== "") {
      if (this.EditRef) {
        content = this.EditRef.current.state.editorContent;
        this.toggleShow();
        EditCommentAPI.editComment(nickname, logo, content, id, tieziid).then(
          (res) => {
            this.toggleShow();
            var code = res.data.code;
            if (code === 1) {
              window.dispatchEvent(
                new CustomEvent("showAlert", {
                  detail: "修改成功",
                })
              );
              this.back();
            } else {
              window.dispatchEvent(
                new CustomEvent("showAlert", {
                  detail: "操作失败",
                })
              );
            }
          }
        );
      }
    } else {
      let content = "";
      if (this.EditRef) {
        content = this.EditRef.current.state.editorContent;
        this.toggleShow();
        EditCommentAPI.addComment(nickname, logo, content, tieziid).then(
          (res) => {
            this.toggleShow();
            var code = res.data.code;
            if (code === 1) {
              window.dispatchEvent(
                new CustomEvent("showAlert", {
                  detail: "添加成功",
                })
              );
              this.back();
            } else {
              window.dispatchEvent(
                new CustomEvent("showAlert", {
                  detail: "操作失败",
                })
              );
            }
          }
        );
      }
    }
  }

  render() {
    const { imgArr, content, nickname } = this.state;
    return (
      <React.Fragment>
        <Loading {...this.props} loadingShow={this.state.loadingShow} />
        <div className="addComment-page">
          <div className="head">
            <CloseIcon
              size={26}
              className="icon"
              color="#696cff"
              onClick={this.back}
            />
          </div>
          <div className="row">
            <div className="title">头像：</div>
            {imgArr.map((item, index) => {
              return (
                <div className="image" key={index}>
                  <AddIcon size={20} color="#696cff" className="file-icon" />
                  {item && item !== "" && (
                    <div className="img-box">
                      <img src={BASE_URL + item} alt="" />
                    </div>
                  )}
                  {(!item || item === "") && <p className="txt">头像</p>}
                  <input
                    type="file"
                    className="file-box"
                    onChange={(e) => this.UpdateImg(e, index)}
                  />
                </div>
              );
            })}
          </div>
          <div className="row">
            <div className="title">评论人：</div>
            <input
              type="text"
              value={nickname || ""}
              onChange={(e) => this.changeInput(e)}
            />
          </div>
          <div className="row">
            <div className="title">评论内容 : </div>
            <Edit {...this.props} ref={this.EditRef} value={content || ""} />
          </div>
          <div className="footer">
            <SubmitIcon
              size={20}
              color="#696cff"
              className="icon"
              onClick={this.submit}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default AddComment;
